import { combineReducers } from 'redux';
import CartReducer from './AddToCart/Cart-Reducer';
import WishlistReducer from './AddToWishlist/Wishlist-Reducer';
import ReducerFilterChip from './FilterChipData/FilterChipData-Reducer';
import UserReducer from './UserData/User-Reducer';
import EditCourse from './EditCourse/EditCourse-Reducer';
import TaskReducer from './Task/Task-Reducer';
import AssignAccessReducer from './AssignAccess/AssignAccess-Reducers';
import { dashboardReducer } from './Slices/dashboardSlice';
import { chatReducer } from './Slices/chatSlice';
const RootReducer = combineReducers({
  CartReducer,
  WishlistReducer,
  ReducerFilterChip,
  UserReducer,
  EditCourse,
  TaskReducer,
  AssignAccessReducer,
  dashboardReducer,
  chatReducer
});
export default RootReducer;
